import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKey as projectmeldingQueryKey } from '../../projectmelding/hooks/useProjectmelding'
import { useAlerts } from '../../theme/hooks/useAlerts'
import { queryKey as projectdossiersQueryKey } from '../hooks/useProjectdossiersSearch'
import { createProjectdossier } from '../services/createProjectdossier'

export { useCreateProjectdossier }

const useCreateProjectdossier = () => {
  const queryClient = useQueryClient()
  const { successAlert, errorAlert } = useAlerts()

  return useMutation({
    mutationFn: createProjectdossier,
    onSuccess: (data) => {
      if (data.projectmeldingId) {
        queryClient.invalidateQueries({
          queryKey: [projectmeldingQueryKey, data.projectmeldingId],
        })
      }
      queryClient.invalidateQueries({ queryKey: [projectdossiersQueryKey] })

      successAlert('Projectdossier successvol aangemaakt')
    },
    onError: (error: any) => {
      errorAlert('Fout bij aanmaken projectdossier', error)
    },
  })
}
